import { SELF_SERVICE_ONBOARDING_FLAG } from '@super/shared-types'

export const FeatureFlags = {
  REPORTING: 'reporting',
  OUTBOUND: 'outbound',
  INBOUND_MULTI_AGENT: 'inbound-multi-agent',
  OWNER_LEAD_MEETING_SKILL: 'owner-lead-meeting-skill',
  SELF_SERVICE_ONBOARDING: SELF_SERVICE_ONBOARDING_FLAG,
  NODE_AGENTS: 'node-agents',
} as const

export type FeatureFlagKey = keyof typeof FeatureFlags
export type FeatureFlagValue = (typeof FeatureFlags)[FeatureFlagKey]
export type FeatureFlag = FeatureFlagValue | string
